<div class="knowledge-quotation">
  <div class="knowledge-quotation__tip" *ngIf="this.knowledgeSummary?.knowledgeConverted === false"
    >※まだナレッジ化されていない投稿です</div
  >
  <app-button (showList)="onShowList($event)" (clickButton)="onCreateQuotation($event)">{{ label }}</app-button>
</div>
